import React, { Component } from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import ForgotLoginForm from './forms/ForgotLoginForm';

import {
    FORGOTLOGIN_LOADED,
    FORGOTLOGIN_UNLOADED
} from '../constants/actionTypes';

const mapStateToProps = state => ({
    ...state.ForgotLogin,
    appName: state.common.appName
});

const mapDispatchToProps = dispatch => ({
    onLoad: () =>
        dispatch({ type: FORGOTLOGIN_LOADED }),
    onUnload: () =>
        dispatch({ type: FORGOTLOGIN_UNLOADED })
});

class ForgotLogin extends Component {
    componentWillMount() {
        this.props.onLoad();
    }

    componentWillUnmount() {
        this.props.onUnload();
    }

    render() {
        const containerStyle = { zIndex: 1999 };
        return (
            <div className="app flex-row align-items-center">
                <ToastContainer position="top-right" autoClose={5000} style={containerStyle} />
                <Container>
                    <Row className="justify-content-center">
                        <Col md="6">
                            <Card className="mx-4">
                                <CardBody className="p-4">
                                    <h2>Recover Your Login Information</h2>
                                    <p className="text-muted">
                                        Please enter your email address and your requested login information
                                        will be sent to the address.
                                    </p>
                                    <ForgotLoginForm />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotLogin);


// WEBPACK FOOTER //
// ./src/containers/ForgotLogin.js